import { gql } from "@apollo/client";

import CommonRecognitionArtifactFragment from "@graphql/common-recognition-artifact-fragment";

export default gql`
  ${CommonRecognitionArtifactFragment}
  query getRelatedRecognitionForCoreValueQuestion(
    $organizationId: Int!
    $coreValueId: Int!
    $recipientId: Int
    $createdBy: Int
    $createdBetweenDates: [Date!]!
  ) {
    artifacts(
      artifactType: recognition
      orderBy: "-created"
      recognitionCoreValue: $coreValueId
      recognitionRecipient: $recipientId
      createdBy: $createdBy
      organizationId: $organizationId
      createdBetweenDates: $createdBetweenDates
    ) {
      edges {
        node {
          id
          ... on RecognitionArtifactNode {
            ...CommonRecognitionArtifactFragment
          }
        }
      }
    }
  }
`;
